/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { useMemo } from 'react';
import { renderToString } from 'react-dom/server';
import L, {
  LatLng,
  LeafletMouseEvent,
  MarkerCluster
} from 'leaflet';
import afMarkerIcon from 'assets/topology/AF_Network_Element.svg';
import cfMarkerIcon from 'assets/topology/CF_Network_Element.svg';
import upfMarkerIcon from 'assets/topology/AF/AF-UPF.svg';
import smfMarkerIcon from 'assets/topology/AF/AF-SMF.svg';
import { NetworkElementProps } from 'data/network-topology/network-topology.types';
import _ from 'lodash';
import * as actions from 'data/accessFunction/accessFunction.actions';
import * as collectionFunctionActions from 'data/collectionFunction/collectionFunction.actions';
import { ConnectedProps, connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { RootState } from 'data/root.reducers';
import xcipioClusterMarkerIcon from 'assets/topology/Xcipio_Cluster.svg';
import ccpagMarkerIcon from 'assets/topology/ccpag.svg';
import MarkerClusterGroup from './MarkerClusterGroup';
import NetworkElement, { XcipioMarkerIcon } from './NetworkElement';
import './map.scss';
import ConnectionGenerator from './ConnectionGenerator';
import { NeEdge } from './utils/MapHelper';
import XcipioMarker, { getMarkerIconByType } from './XcipioMarker';
import { createClusterPopup } from './utils/tooltipData';
import 'leaflet-responsive-popup';
import 'leaflet-responsive-popup/leaflet.responsive.popup.css';

const mapState = (state: RootState) => ({});

const mapDispatch = {
  goToAccessFunctionView: actions.goToAccessFunctionView,
  selectAccessFunction: actions.selectAccessFunction,
  selectCollectionFunction: collectionFunctionActions.selectCollectionFunction,
  goToCollectionFunctionView: collectionFunctionActions.goToCollectionFunctionView
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;
type PropsFromRouter = RouteComponentProps<RouterParams>;

type RouterParams = {
  history: string;
};

type Props = {
 afMarkers: NetworkElementProps[];
 cfMarkers: NetworkElementProps[];
 xcipioNodes: any[];
 ccpags: any[];
 mdf2s: any[],
 mdf3s: any[],
 admfs: any[],
 xcipioRef: any;
 afClusterGroupRef: any,
 cfClusterGroupRef: any,
 ccpagClusterGroupRef: any,
 mdf2ClusterGroupRef: any,
 mdf3ClusterGroupRef: any,
 admfClusterGroupRef: any,
 onHover: any,
 handleZoom: any,
 lines: NeEdge[],
 mapHelper: any,
 onDragEnd: any,
 setClusterExpansionList: any,
} & PropsFromRedux & PropsFromRouter;

const NeClusterGroupGenerator = React.memo(
 ({
   afMarkers,
   cfMarkers,
   xcipioNodes,
   ccpags,
   mdf2s,
   mdf3s,
   admfs,
   xcipioRef,
   afClusterGroupRef,
   cfClusterGroupRef,
   ccpagClusterGroupRef,
   mdf2ClusterGroupRef,
   mdf3ClusterGroupRef,
   admfClusterGroupRef,
   onHover,
   handleZoom,
   lines,
   mapHelper,
   onDragEnd,
   setClusterExpansionList,
 }: Props) => {

    const iconCreateFunctionAF = (cluster: MarkerCluster) => {
      const childCount = cluster.getChildCount();
      const typeStatusMap: {[type: string]: {[status: string]: number}} = cluster.getAllChildMarkers()
      .map((c) => {
        const details = (c.options as any)['data-original'];
        return {
          poiType: details.poiType,
          status: details.status
        }
      }).reduce((acc, curr) => {
        if (!acc[curr.poiType]) {
          acc[curr.poiType] = {
            [curr.status]: 1
          };
        } else {
          acc[curr.poiType] = {
            ...acc[curr.poiType],
            [curr.status]: acc[curr.poiType][curr.status] + 1
          };
        }
        return acc;
      }, {} as any);
      let icon = afMarkerIcon;
      if (Object.keys(typeStatusMap).length === 1) {
        const poiType = Object.keys(typeStatusMap)[0];
        icon = getAFMarkerIconByType(poiType);
      }
      const statusMap = Object.entries(typeStatusMap).reduce((acc, curr) => {
        Object.keys(curr[1])
        .forEach((status) => {
          if (!acc[status]) {
            acc[status] = 1;
          } else {
            acc[status] += 1;
          }
        })
        return acc;
      }, {} as any);
      const badgeClass = getBadgeClassByStatusMap(statusMap);
      const myIcon = L.divIcon({
        html: `<img src=${icon} class='marker-shadow'><div class='badge ${badgeClass}'>${childCount}</div>`,
        className: 'cluster',
        iconSize: [40, 40]
      });
      return myIcon;
    };

    const iconCreateFunctionCF = (cluster: MarkerCluster) => {
      const childCount = cluster.getChildCount();
      const statusMap = cluster.getAllChildMarkers()
      .map((m) => (m.options as any)['data-original'].status)
      .reduce((acc, status) => {
        if (!acc[status]) {
          acc[status] = 1;
        } else {
          acc[status] += 1;
        }
        return acc;
      }, {} as any);
      const badgeClass = getBadgeClassByStatusMap(statusMap);
      const myIcon = L.divIcon({
        html: `<img src=${cfMarkerIcon} class='marker-shadow'><div class='badge ${badgeClass}'>${childCount}</div>`,
        className: 'cluster',
        iconSize: [40, 40]
      });
      return myIcon;
    };

    const handleClusterClick = (event: LeafletMouseEvent) => {
      let target = event.propagatedFrom;
      if (!target) {
        target = event.target;
      }

      // if (target instanceof L.MarkerCluster) {
      //   setClusterExpansionList(target.getAllChildMarkers())
      // }
      // if (event.sourceTarget._childClusters.length === 0){
      //   setClusterExpansionList(event.sourceTarget._markers)
      // }
      // clicked += 1;
      setTimeout(() => {
        // if (clicked === 1) {
          // clicked = 0;
          if (event.sourceTarget instanceof L.MarkerCluster) {
            const cluster = event.sourceTarget as MarkerCluster;
            if (mapHelper && mapHelper.current) {
              const popup = L.responsivePopup({ offset: [20, 20] }).setContent(createClusterPopup((cluster as any)._leaflet_id, mapHelper.current, () => handleViewMore(cluster)))
              cluster.bindPopup(popup).openPopup();
            }
          }
        // }
      }, 300);
    };

    const handleViewMore = (cluster: L.MarkerCluster) => {
      if (cluster) {
        setClusterExpansionList(cluster.getAllChildMarkers());
      }
      cluster.closePopup();
    };

    const clusterRadius = (mapZoom: number) => {
      //  if (mapZoom >= 7) {
      //    return 0;
      //  }
      return 300;
    };

    const iconCreateCcpag = (cluster: MarkerCluster) => {
      const childCount = cluster.getChildCount();
      const childMarkersLocations: LatLng[] = [];
      const statusMap = cluster.getAllChildMarkers()
      .map((m) => (m.options as any)['data-original'].status)
      .reduce((acc, status) => {
        if (!acc[status]) {
          acc[status] = 1;
        } else {
          acc[status] += 1;
        }
        return acc;
      }, {} as any);
      const badgeClass = getBadgeClassByStatusMap(statusMap);
      cluster.getAllChildMarkers().forEach((marker: any) => {
        childMarkersLocations.push(marker.getLatLng());
      });
      const myIcon = L.divIcon({
        html: `<img src=${ccpagMarkerIcon} class='marker-shadow'><div class='badge ${badgeClass}'>${childCount}</div>`,
        className: 'cluster',
        iconSize: [40, 40]
      });
      return myIcon;
    }

    const iconCreateXcipioFunction = (cluster: MarkerCluster) => {
      const childCount = cluster.getChildCount();
      const typeStatusMap: {[type: string]: {[status: string]: number}} = cluster.getAllChildMarkers()
      .map((c) => {
        const details = (c.options as any)['data-original'];
        return {
          nodeType: details.data.nodeType,
          status: details.status
        }
      }).reduce((acc, curr) => {
        if (!acc[curr.nodeType]) {
          acc[curr.nodeType] = {
            [curr.status]: 1
          };
        } else {
          acc[curr.nodeType] = {
            ...acc[curr.nodeType],
            [curr.status]: acc[curr.nodeType][curr.status] + 1
          };
        }
        return acc;
      }, {} as any);
      let icon = xcipioClusterMarkerIcon;
      if (Object.keys(typeStatusMap).length === 1) {
        const nodeType = Object.keys(typeStatusMap)[0];
        icon = getMarkerIconByType(nodeType);
      }
      const statusMap = Object.entries(typeStatusMap).reduce((acc, curr) => {
        Object.keys(curr[1])
        .forEach((status) => {
          if (!acc[status]) {
            acc[status] = 1;
          } else {
            acc[status] += 1;
          }
        })
        return acc;
      }, {} as {[key: string]: number});
      const badgeClass = getBadgeClassByStatusMap(statusMap);
      const myIcon = L.divIcon({
        html: renderToString(XcipioMarkerIcon(icon, badgeClass, childCount, _.has(statusMap, 'LEADER'))),
        className: 'cluster',
        iconSize: [40, 40]
      });
      return myIcon;
    };

    const getBadgeClassByStatusMap = (statusMap: {[status: string]: number}) => {
      let badgeClass = '';
      if (statusMap.FAILED > 0) {
        badgeClass = 'badge-failed';
      }
      if (statusMap.INACTIVE > 0 && !badgeClass) {
        badgeClass = 'badge-inactive';
      }
      if (statusMap.ACTIVE > 0 && !badgeClass) {
        badgeClass = 'badge-active';
      }
      return badgeClass;
    }

    const getAFMarkerIconByType = (poiType: string) => {
      if (poiType === 'UPF') {
        return upfMarkerIcon;
      }
      if (poiType === 'SMF') {
        return smfMarkerIcon;
      }
      return afMarkerIcon;
    }

    const markerClusterGroup = useMemo(() => {
      return (
        <React.Fragment>
          <MarkerClusterGroup
            ref={afClusterGroupRef}
            iconCreateFunction={iconCreateFunctionAF}
            onClick={handleClusterClick}
            onMouseOver={onHover}
            showCoverageOnHover={false}
            chunkedLoading
            removeOutsideVisibleBounds={false}
            singleMarkerMode={false}
            onAnimationend={handleZoom}
            spiderfyOnMaxZoom={false}
            zoomToBoundsOnClick={false}
            maxClusterRadius={clusterRadius}
          >
            {afMarkers.map((af, index) => {
              if (!af.location) return;
              return (
                <NetworkElement
                  key={af.data?.id}
                  id={af.data?.id}
                  position={{
                    lat: af.location.latitude,
                    lng: af.location.longitude
                  }}
                  type="AF"
                  details={af}
                  onDragEnd={onDragEnd}
                  onHover={onHover}
                  // enabledCollectionFunctions={enabledCollectionFunctions}
                />
              );
            })}
          </MarkerClusterGroup>
          <MarkerClusterGroup
            ref={cfClusterGroupRef}
            iconCreateFunction={iconCreateFunctionCF}
            onClick={handleClusterClick}
            onMouseOver={onHover}
            showCoverageOnHover={false}
            chunkedLoading
            removeOutsideVisibleBounds={false}
            singleMarkerMode={false}
            onAnimationend={handleZoom}
            spiderfyOnMaxZoom={false}
            zoomToBoundsOnClick={false}
            maxClusterRadius={300}
          >
            {cfMarkers.map((cf, index) => {
              if (!cf.location) return;
              return (
                <NetworkElement
                  key={cf.data?.id}
                  id={cf.data?.id}
                  position={{
                    lat: cf.location.latitude,
                    lng: cf.location.longitude
                  }}
                  type="CF"
                  details={cf}
                  onDragEnd={onDragEnd}
                  onHover={onHover}
                  // enabledCollectionFunctions={enabledCollectionFunctions}
                />
              );
            })}
          </MarkerClusterGroup>
          <MarkerClusterGroup
            ref={xcipioRef}
            iconCreateFunction={iconCreateXcipioFunction}
            onClick={handleClusterClick}
            onMouseOver={onHover}
            showCoverageOnHover={false}
            chunkedLoading
            removeOutsideVisibleBounds={false}
            singleMarkerMode={false}
            onAnimationend={handleZoom}
            spiderfyOnMaxZoom={false}
            zoomToBoundsOnClick={false}
            maxClusterRadius={400}
          >
            {xcipioNodes.map((xcipio, index) => {
              if (!xcipio.location) return;

              return (
                <XcipioMarker
                  key={xcipio.data.id}
                  data={xcipio.data}
                  details={xcipio}
                  position={{
                    lat: xcipio.location.latitude,
                    lng: xcipio.location.longitude
                  }}
                  onHover={onHover}
                />
              );
            })}
          </MarkerClusterGroup>
          <MarkerClusterGroup
            ref={ccpagClusterGroupRef}
            iconCreateFunction={iconCreateCcpag}
            onClick={handleClusterClick}
            onMouseOver={onHover}
            showCoverageOnHover={false}
            chunkedLoading
            removeOutsideVisibleBounds={false}
            singleMarkerMode={false}
            onAnimationend={handleZoom}
            spiderfyOnMaxZoom={false}
            zoomToBoundsOnClick={false}
            maxClusterRadius={300}
          >
            {ccpags.map((ccpag, index) => {
              if (!ccpag.location) return;

              return (
                <XcipioMarker
                  key={ccpag.data.id}
                  data={ccpag.data}
                  details={ccpag}
                  position={{
                    lat: ccpag.location.latitude,
                    lng: ccpag.location.longitude
                  }}
                  onHover={onHover}
                />
              );
            })}
          </MarkerClusterGroup>
          <MarkerClusterGroup
            ref={mdf2ClusterGroupRef}
            iconCreateFunction={iconCreateXcipioFunction}
            onClick={handleClusterClick}
            onMouseOver={onHover}
            showCoverageOnHover={false}
            chunkedLoading
            removeOutsideVisibleBounds={false}
            singleMarkerMode={false}
            onAnimationend={handleZoom}
            spiderfyOnMaxZoom={false}
            zoomToBoundsOnClick={false}
            maxClusterRadius={400}
          >
            {mdf2s.map((mdf2, index) => {
              if (!mdf2.location) return;

              return (
                <XcipioMarker
                  key={mdf2.data.id}
                  data={mdf2.data}
                  details={mdf2}
                  position={{
                    lat: mdf2.location.latitude,
                    lng: mdf2.location.longitude
                  }}
                  onHover={onHover}
                />
              );
            })}
          </MarkerClusterGroup>
          <MarkerClusterGroup
            ref={mdf3ClusterGroupRef}
            iconCreateFunction={iconCreateXcipioFunction}
            onClick={handleClusterClick}
            onMouseOver={onHover}
            showCoverageOnHover={false}
            chunkedLoading
            removeOutsideVisibleBounds={false}
            singleMarkerMode={false}
            onAnimationend={handleZoom}
            spiderfyOnMaxZoom={false}
            zoomToBoundsOnClick={false}
            maxClusterRadius={400}
          >
            {mdf3s.map((mdf3, index) => {
              if (!mdf3.location) return;

              return (
                <XcipioMarker
                  key={mdf3.data.id}
                  data={mdf3.data}
                  details={mdf3}
                  position={{
                    lat: mdf3.location.latitude,
                    lng: mdf3.location.longitude
                  }}
                  onHover={onHover}
                />
              );
            })}
          </MarkerClusterGroup>
          <MarkerClusterGroup
            ref={admfClusterGroupRef}
            iconCreateFunction={iconCreateXcipioFunction}
            onClick={handleClusterClick}
            onMouseOver={onHover}
            showCoverageOnHover={false}
            chunkedLoading
            removeOutsideVisibleBounds={false}
            singleMarkerMode={false}
            onAnimationend={handleZoom}
            spiderfyOnMaxZoom={false}
            zoomToBoundsOnClick={false}
            maxClusterRadius={400}
          >
            {admfs.map((admf, index) => {
              if (!admf.location) return;

              return (
                <XcipioMarker
                  key={admf.data.id}
                  data={admf.data}
                  details={admf}
                  position={{
                    lat: admf.location.latitude,
                    lng: admf.location.longitude
                  }}
                  onHover={onHover}
                />
              );
            })}
          </MarkerClusterGroup>
        </React.Fragment>
      );
    }, [afMarkers, cfMarkers]);

    return (
      <React.Fragment>
        <ConnectionGenerator lines={lines} />
        {markerClusterGroup}
      </React.Fragment>
    );
  }
);

export default withRouter(connector(NeClusterGroupGenerator));
